import ClientAPI from '../../common/ClientAPI'
import constants from '../../common/constants'

const clientAPI = new ClientAPI()

export const retryQueryBase = async (body, shouldGetCategoryLevel1 = true) => {
  const options = { ...body }
  const categories = body.categories.split('/')
  let relatedProduct = []
  const searchResult = await clientAPI.category(options)

  if (searchResult.products.length === 0 && categories.length > 1) {
    options.categories = `${categories[0]}/${categories[1]}`
    const { products } = await clientAPI.category(options)
    relatedProduct = products
  }

  if (
    shouldGetCategoryLevel1 &&
    relatedProduct.length < 6 &&
    searchResult.products.length === 0 &&
    categories.length > 1
  ) {
    options.categories = `${categories[0]}`
    const { products } = await clientAPI.category(options)
    products.forEach((e) => relatedProduct.push(e))
  }

  return { searchResult, relatedProduct }
}

export const getFiltersByCategory = (categories, categoryList) => {
  const [first, second, third] = categoryList
  const baseFilters = constants.FILTERS.BASE_CATEGORY_FILTERS
  let filters = [...baseFilters]
  if (categories.length > 0) {
    const firstLevelConfig = categories.find((category) => category.label === first) || {}
    if (firstLevelConfig.filters !== undefined) {
      filters = filters.concat(firstLevelConfig.filters)
    }
    if (second !== undefined && firstLevelConfig.categoriesLevel2) {
      const secondLevelConfig = firstLevelConfig.categoriesLevel2.find((category) => category.label === second) || {}
      filters = [...baseFilters]
      if (secondLevelConfig.filters !== undefined) {
        filters = filters.concat(secondLevelConfig.filters)
      }
      if (third !== undefined && secondLevelConfig.categoriesLevel3) {
        const thirdLevelConfig = secondLevelConfig.categoriesLevel3.find((category) => category.label === third) || {}
        filters = [...baseFilters]
        if (thirdLevelConfig.filters !== undefined) {
          filters = filters.concat(thirdLevelConfig.filters)
        }
      }
    }
  }
  return [
    ...new Set(
      filters.map((filter) => {
        if (filter === 'Precio') {
          return `price.${filter}`
        }
        return `filters.${filter}`
      })
    ),
  ]
}

export const getCategoryDataBase = (categoryList, categories) => {
  let categoryFilters
  let title
  let lastCategory
  if (categoryList) {
    categoryFilters = getFiltersByCategory(categories, categoryList)
    const [category1, category2, category3] = categoryList
    title = category1
    lastCategory = category1
    if (category2) {
      title = `${category2} en ${category1}`
      lastCategory = category2
    }
    if (category3) {
      title = `${category3} en ${category2}`
      lastCategory = category3
    }
  }
  return { categoryFilters, title, lastCategory }
}

export const detectDevice = (_width, windowSize) => {
  const device = {
    isMobile: false,
    isTablet: false,
  }
  if (windowSize.width === 768) {
    device.isTablet = true
  }
  if (windowSize.width !== 768) {
    device.isTablet = false
  }
  if (windowSize.width < 768) {
    device.isMobile = true
  }
  if (windowSize.width > 768) {
    device.isMobile = false
  }
  return device
}
